// extracted by mini-css-extract-plugin
export default {"area":"K4dbpI","mobile":"Qeq976","label":"HOurC9","occupiedArea":"ZdHKWE"};